var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"35.22.1"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import { commonConfig } from '@bridebook/toolbox/src/sentry/sentry-client-config';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  ...commonConfig,
  ignoreErrors: ['auth/email-already-in-use', 'auth/account-exists-with-different-credential'],
  integrations: [
    new Sentry.BrowserTracing({
      // Need to be more specific about localhost as by default it was checking the whole url for the 'localhost' string and it was attaching extra headers to the requests
      tracePropagationTargets: [/^https:\/\/localhost/, /^http:\/\/localhost/, /^\//],
    }),
  ],
  beforeSend(event) {
    if (
      event?.exception?.values?.some((exception) =>
        exception?.value?.startsWith(
          'refusing to open IndexedDB database due to potential corruption of the IndexedDB database data; this corruption could be caused by clicking the "clear site data" button in a web browser;',
        ),
      )
    ) {
      return null;
    }

    return event;
  },
});
